Soho.quantityControls = [];

Soho.quantityControl = function() {
    var quantityControlInput = document.querySelectorAll('[quantity-control]');

    for (var i = 0; i < quantityControlInput.length; i++) {
        (function(i) {
            var quantityControl = new Soho.QuantityControl({
                el: quantityControlInput[i],
                mode: quantityControlInput[i].getAttribute('quantity-control'),
                id: 'quantity-control-' + i
            });
            quantityControl.init();

            Soho.quantityControls.push(quantityControl);
        })(i);
    }
};
